/*#__PURE__*/ export default JSON.parse('{"key":"betSharing","type":"root","items":[{"key":"maximumNumberOfSelectionsToShare","def":6,"type":"int"}]}');